import React from "react";
import emptyDishes from "../images/emptyDishes.png";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { WithRoleAccess } from "@services/ui-components";
import { CompanyAccess } from "@me-team/host/main/graphql/types";
import { useRoleAccess } from "@me-team/host/src/utils/useRoleAccess";

export const EmptyDishList: React.FC = () => {
    const { t: translate } = useTranslation();
    const { branchId } = useParams();
    const canCreateDish = useRoleAccess(CompanyAccess.MenuDishCreate);

    return (
        <div className="d-flex justify-content-center align-items-center flex-column py-4">
            <img className={"d-block"} src={emptyDishes} alt="emptyDishListBySearchImg" />
            <h2 className={"fs-24 fw-bold my-3"}>{translate("Dishes have not been created yet")}</h2>
            <WithRoleAccess permission={CompanyAccess.MenuDishCreate}>
                <Link
                    to={`/menu/dishes/create-dish/branch/${String(branchId).trim()}`}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-primary px-4 py-6"
                    onClick={(event) => {
                        if (!canCreateDish) event.preventDefault();
                    }}
                >
                    <i className="bi bi-plus-lg me-2 fs-16"></i>
                    <span className="fs-7 fw-bold">{translate("Create dish")}</span>
                </Link>
            </WithRoleAccess>
        </div>
    );
};
